import React, {Component} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import {Container} from 'reactstrap'
import Header from '../../components/Header/'
import Sidebar from '../../components/Sidebar/'
import Breadcrumb from '../../components/Breadcrumb/'

import Home from '../../views/Home/'
import Profiles from '../../views/Profiles/'
import ViewEditProfile from '../../views/Profiles/ViewEditProfile'
import Events from '../../views/Events/'
import Settings from '../../views/Settings/'

import Auth from '../../modules/Auth'
import { get } from '../../modules/API'


class Full extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      fetchedData: {
        userInfo: {},
        userProfiles: [],
        userEvents: []
      }
    }
  }

  componentDidMount() {
    if (Auth.isUserAuthenticated()) {
      get('users/current').then(currentUser => {
        Promise.all([
          get(`sales-profiles?manager_id=${currentUser.id}`),
          get('events')
        ]).then(data => {
          this.setState({
            loaded: true,
            fetchedData: {
              userInfo: currentUser,
              userProfiles: data[0].results || [],
              userEvents: data[1].results || []
            }
          })
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    return this.state.loaded && (
      <div className="app">
        <Header {...this.state.fetchedData} />
        <div className="app-body">
          <Sidebar {...this.props} {...this.state.fetchedData} />
          <div className="main">
            <Breadcrumb />
            <Container>
              <Switch>
                <Route path="/home" render={props => <Home {...props} {...this.state.fetchedData} />} />
                <Route exact path="/profiles" render={props => <Profiles {...props} {...this.state.fetchedData} />} />
                <Route path="/profiles/:id" render={props => <ViewEditProfile {...props} {...this.state.fetchedData} />} />
                <Route exact path="/termine" render={props => <Events {...props} {...this.state.fetchedData} />} />
                <Route path="/settings" render={props => <Settings {...props} {...this.state.fetchedData} />} />
                <Redirect exact from="/" to="/home" />
                <Redirect to="/404" />
              </Switch>
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

export default Full



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js